export enum ViewerGuideType {
  Forward = 'Forward',
  Reverse = 'Reverse',
  Scroll = 'Scroll',
  Tap = 'Tap',
}
